import { useState } from 'react';

const faqs = [
  {
    q: '¿Es un pago mensual?',
    a: 'No, es un único pago de S/ 10.00 que te cubre por todo un año completo. Sin renovaciones automáticas, sin sorpresas. Pagas una vez y te olvidas por 12 meses.',
  },
  {
    q: '¿Son programas piratas o APKs?',
    a: 'Para nada. Son cuentas 100% oficiales de las plataformas originales. Nada de archivos raros, nada de APKs modificados que pongan en riesgo tu equipo o tu información. Acceso legítimo y seguro.',
  },
  {
    q: '¿En qué dispositivos lo puedo usar?',
    a: 'Compatible con Laptop, PC, celular y tablet. Un solo acceso para todos tus dispositivos. No importa si usas Windows, Mac, Android o iOS.',
  },
  {
    q: '¿Cómo recibo el acceso?',
    a: 'Inmediatamente después de tu pago, recibirás las credenciales directamente para entrar a tu ecosistema completo. El proceso es automático y toma menos de 5 minutos.',
  },
  {
    q: '¿Qué pasa si tengo problemas con alguna herramienta?',
    a: 'Contamos con soporte dedicado para nuestra comunidad élite. Si tienes cualquier inconveniente con tu acceso, te ayudamos a resolverlo sin costo adicional.',
  },
  {
    q: '¿Puedo compartir el acceso con otras personas?',
    a: 'El acceso es personal e intransferible. Está diseñado para un solo usuario, lo que garantiza la estabilidad y seguridad de tu cuenta durante todo el año.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="faq" className="relative bg-gradient-to-b from-[#0a0a0a] to-[#111827] py-20 md:py-32 px-4">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#8b5cf6]/20 to-transparent" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-4 md:mb-5 bg-[#8b5cf6]/10 border border-[#8b5cf6]/30 rounded-2xl">
            <i className="ri-question-line text-xl md:text-2xl text-[#8b5cf6]"></i>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white">
            Preguntas{' '}
            <span className="bg-gradient-to-r from-[#8b5cf6] to-[#10b981] bg-clip-text text-transparent">
              Frecuentes
            </span>
          </h2>
          <p className="text-gray-400 mt-3 md:mt-4 text-sm md:text-base">
            Todo lo que necesitas saber antes de tomar la mejor decisión de tu año.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className="rounded-2xl overflow-hidden transition-all duration-300"
                style={{
                  border: isOpen ? '1.5px solid #8b5cf6' : '1.5px solid #1f2937',
                  boxShadow: isOpen ? '0 0 20px rgba(139,92,246,0.15)' : 'none',
                }}
              >
                {/* Question */}
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex items-center justify-between gap-3 px-4 md:px-6 py-4 md:py-5 text-left cursor-pointer bg-[#111827] hover:bg-[#1a2234] transition-colors duration-200"
                >
                  <span className="text-white font-bold text-sm md:text-lg leading-snug flex-1">
                    {faq.q}
                  </span>
                  <div
                    className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-[#8b5cf6]/10 transition-transform duration-300"
                    style={{ transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)' }}
                  >
                    <i className="ri-arrow-right-s-line text-[#8b5cf6] text-lg md:text-xl"></i>
                  </div>
                </button>

                {/* Answer */}
                <div
                  className="overflow-hidden transition-all duration-300"
                  style={{ maxHeight: isOpen ? '300px' : '0px' }}
                >
                  <div className="px-4 md:px-6 py-4 md:py-5 bg-[#0d1117] border-t border-[#1f2937]">
                    <p className="text-gray-300 text-sm md:text-base leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-10 md:mt-14 text-center">
          <p className="text-gray-400 text-sm md:text-base mb-5 md:mb-6">
            ¿Aún tienes dudas? La mejor forma de resolverlas es dando el paso. 🚀
          </p>
          <a
            href="https://wa.link/mbtq6u"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-[#8b5cf6] to-[#ec4899] text-white font-black text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full cursor-pointer hover:scale-105 transition-transform duration-200 shadow-[0_0_25px_rgba(139,92,246,0.4)]"
          >
            ⚡ Quiero mi acceso ahora
          </a>
        </div>
      </div>
    </section>
  );
}
